import * as _4 from 'lodash4';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APGenericSlot, CourseSlot } from '../../builders/ap_generic_slot_builder';
import { APAdvisorText } from './../../servants/ap_advisor_text_servant';
class CourseTileComponentController {
  private courseColor: string = 'blue';
  private titleCssClass: string;
  private courseInfoIconTheme: string;
  private courseInfoIconTitle: string;
  private statePrefix: string;
  private advisorLabel: string;
  private hasRequisiteProblem: boolean = false;
  private genericSlot: CourseSlot;
  private courseTileId: string;
  constructor(
    private $state: ng.ui.IStateService,
    private phxFeatureConfiguration: any,
    private ngAPAdvisorText: APAdvisorText,
    private phxFocusDelegate: any
  ) {}

  initialize() {
    this.hasRequisiteProblem = this._hasRequisiteProblem;
    if (_4.get(this.genericSlot, 'plannedCourse._hasRequisiteProblem', false) && this.genericSlot.termId) {
      this.courseInfoIconTheme = 'red';
      this.courseInfoIconTitle = 'Course quick information, this course needs attention.';
    } else {
      this.courseInfoIconTheme = 'gray';
      this.courseInfoIconTitle = 'Course quick information';
    }

    this.courseTileId = _4.uniqueId();
    this.statePrefix = this.$state.includes('ap-advisor') ? 'ap-advisor' : 'my';
    this.advisorLabel = this.ngAPAdvisorText.advisorLabel;
  }
  get _hasRequisiteProblem() {
    return _4.get(this.genericSlot, 'plannedCourse._hasRequisiteProblem', false);
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }
}

class CourseTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      genericSlot: '<',
      changeLookWhenHover: '<',
      hideInfo: '<',
      titleCssClass: '@'
    };
    this.controller = CourseTileComponentController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_tile_component/course_tile_component.html';
  }
}

angular.module('capability-ng-academic-planner').component('courseTileComponent', new CourseTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_tile_component/course_tile_component.ts